import LocalStorageProxy from "../../shared/LocalStorageProxy"

export default class GetAwaySearchRepository {
  public static getDateQuery(): string {
    if (!this.isValid()) {
      console.warn('date -invalid')
      return ''
    }

    const dateQuery = LocalStorageProxy.getItem('ga-search-date')
    if (!dateQuery) {
      return ''
    }

    return dateQuery
  }

  public static getPaxQuery(): string {
    if (!this.isValid()) {
      console.warn('pax -invalid')
      return ''
    }

    const paxQuery = LocalStorageProxy.getItem('ga-search-pax')
    if (!paxQuery) {
      return ''
    }

    return paxQuery
  }

  public static storeDateQuery(dateQuery: string) {
    LocalStorageProxy.setItem('ga-search-timestamp', Date.now().toString())
    LocalStorageProxy.setItem('ga-search-date', dateQuery)
  }

  public static storePaxQuery(paxQuery: string) {
    LocalStorageProxy.setItem('ga-search-timestamp', Date.now().toString())
    LocalStorageProxy.setItem('ga-search-pax', paxQuery)
  }

  public static isValid(): boolean {
    const timestamp = LocalStorageProxy.getItem('ga-search-timestamp')
    if (!timestamp) {
      return false
    }

    const MIN_10 = 1000 * 60 * 10
    const time = Number(timestamp)

    const now = Date.now()

    if ((time + MIN_10) < now) {
      LocalStorageProxy.removeItem('ga-search-timestamp')
      LocalStorageProxy.removeItem('ga-search-date')
      LocalStorageProxy.removeItem('ga-search-pax')

      return false
    }

    return true
  }
}
